import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

interface SnackbarConfig {
  actionText?: string;
  duration?: number;
}

@Injectable({
    providedIn: 'root',
})
export class SnackbarService {

  constructor(private snackbar: MatSnackBar) {}

  normal(message: string, config: SnackbarConfig = {}) {
    const { actionText = $localize`:@@js_Close:Cerrar`, duration = 7000 } = config;

    this.snackbar.open(message, actionText, {
      duration,
    });
  }

  error(message: string, config: SnackbarConfig = {}) {
    const { actionText = $localize`:@@js_Close:Cerrar`, duration = 7000 } = config;

    this.snackbar.open(message, actionText, {
      duration,
      panelClass: ["snackbar-fail"],
    });
  }
}
